import type { NormalisedRequestFilter } from "@onhandtech/onhand-fe-shared/lib/api/v5/request-filter-set/request-filter-set.types";
import type { SectionFilterType } from "redux/sections/sections.types";

export const haveFiltersChanged = (
	selectedSectionFilters: NormalisedRequestFilter[],
	draftFilters: SectionFilterType[],
): boolean =>
	JSON.stringify(
		selectedSectionFilters.map(
			(filter) => filter.requestId ?? filter.taskTypeId ?? filter.tagId,
		),
	) !== JSON.stringify(draftFilters.map(({ filter }) => filter.id));

export const decompileRequestFilters = (
	requestFilters: NormalisedRequestFilter[],
): SectionFilterType[] =>
	requestFilters.reduce(
		(
			acc: SectionFilterType[],
			cur: NormalisedRequestFilter,
		): SectionFilterType[] => {
			if (cur.requestId && cur.request) {
				acc.push({
					type: "action",
					filter: cur.request,
				});
			} else if (cur.taskTypeId && cur.taskType) {
				acc.push({
					type: "task-type",
					filter: cur.taskType,
				});
			}

			return acc;
		},
		[],
	);
